import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';

function FastActions() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  
  const handleHome = () => {
    navigate('/home');
  };

    const handleAddHubFast = () => {
        navigate(`addHub`);
    };

    const handleConfigurePotFast = () => {
      navigate('addPot', { state: { origin_add_pot: true } });
    };

    const handleAddSpaceFast = () => {
      navigate(`/spaces/newSpace`);
      };

    const handleAddPlantToPotFast = () => {
      navigate(`addPot`, { state: { origin_add_pot: false } });
    };
      
  return (
    <div className="general-page">
      <div className="sm-container">
        <div className="header">
            <button onClick={handleHome} className="back-button">&#8592;</button>
            <h1>{translations.fastActions}</h1>
        </div>
        <div className="content">
            <button onClick={handleAddHubFast} className="general-button fastSettings-button">{translations.addHubFast}</button>
        </div>
        <div className="content">
            <button onClick={handleConfigurePotFast} className="general-button fastSettings-button">{translations.configurePotFast}</button>
        </div>
        <div className="content">
            <button onClick={handleAddSpaceFast} className="general-button fastSettings-button">{translations.addSpaceFast}</button>
        </div>
        <div className="content">
            <button onClick={handleAddPlantToPotFast} className="general-button fastSettings-button">{translations.addPlantFast}</button>
        </div>
      </div>
    </div>
  );
}

export default FastActions;
